module.exports = __webpack_public_path__ + "img/pg_tele_d.533799bd.png";